// extracted by mini-css-extract-plugin
module.exports = {"figureContainer":"Bilde_figureContainer__UWCpt","figureSmall":"Bilde_figureSmall__iGfQW","figureMedium":"Bilde_figureMedium__D0DJB","figureFull":"Bilde_figureFull__Ubd0s"};